// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UhpZ","controls":"styles_controls__39Quo","charLimit":"styles_charLimit__1ehM7","input":"styles_input__2AuIk","send":"styles_send__2nS6z"};